import { CalendarView } from "@progress/kendo-angular-dateinputs";

export class KendoDatePickerOptions {
  label: string;
  format: string;
  activeView: CalendarView;
  bottomView: CalendarView;

  constructor(
    label: string,
    format: string,
    activeView: CalendarView,
    bottomView: CalendarView
  ) {
    this.label = label;
    this.format = format;
    this.activeView = activeView;
    this.bottomView = bottomView;
  }

  static dayOptions(): KendoDatePickerOptions {
    return new KendoDatePickerOptions("Date", "dd/MM/yyyy", "month", "month");
  }

  static monthOptions(): KendoDatePickerOptions {
    return new KendoDatePickerOptions(
      "Transaction Month",
      "MMMM yyyy",
      "year",
      "year"
    );
  }
}
